module Meevo.Plugins.NotificationTemplates {
    "use strict";

    import CommunicationTypeEnum = Meevo.Model.CommunicationTypeEnum;

    /**
    * Main Section of SecurityRole 
    */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Meevo.Model.Template> {
        /**
        * Base class override which defines what a DEFAULT model looks like.
        */
        public missingField: any = -1;
        public communicationUserType: any;

        createSectionModelInstance(postAdd: (data: any) => any): void {
            let instance: Model.Template = {
                id: Guid.empty.toString(),
                objectState: Meevo.Model.ObjectStateEnum.Active,
                objectCreationType: Meevo.Model.ObjectCreationTypeEnum.User
            };

            this.model = instance;
        }

        beforeSetFocusOnField() {
            var that = this;

            setTimeout(function () { that.setFocusOnField(that.missingField) }, 400);
        }

        setFocusOnField(field: any) {
            switch (field) {
                default:
                    $("[ng-required='required']:visible:first").focus();
                    break;
            }
        }

        preSave() {
            if (this.model.communicationType === CommunicationTypeEnum.GenericOptInRequested) {
                this.model.emailSubject = '';
                this.model.emailBody = '';
            }

            if (typeof this.model.smsMessage !== 'undefined' && this.model.smsMessage !== "") {
                let parser = new DOMParser();
                let parsedSMSMessage = parser.parseFromString(this.model.smsMessage, 'text/html');
                this.model.smsMessage = parsedSMSMessage.body.textContent;
            }

            if (typeof this.model.emailSubject !== 'undefined' && this.model.emailSubject !== "") {
                let parser = new DOMParser();
                let parsedEmailSubject = parser.parseFromString(this.model.emailSubject, 'text/html');
                this.model.emailSubject = parsedEmailSubject.body.textContent;
            }
        }

        get communicationTypeEnum(): any {
            return CommunicationTypeEnum;
        }

        // sets the smsMessage field to System level GenericOptInRequested SMSMessage.
        setSMSMessage(commType: any, dsCommType: any) {
            if (commType === CommunicationTypeEnum.GenericOptInRequested && dsCommType != null) {
                if (!this.model.smsMessage) {
                    let optInReqObj = dsCommType.filter(d => d.communicationType === commType
                        && d.communicationTypeUser === Meevo.Model.CommunicationTypeUserEnum.Client)
                    this.model.smsMessage = optInReqObj[0].smsMessage;
                }
            }
                        
        }

        
        

        GetCommTypeFilteredList(userType: any, dsCommType: any) {
            if (dsCommType != null && userType != 'undefined' && userType != "") {
                return dsCommType.filter(d=> d.communicationTypeUser == userType);
            }
        }
        
    }

}